var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('clubsidebar'),_c('clubnavigation'),_c('div',{staticClass:"content-wrapper"},[_c('router-view',{key:_vm.$route.fullPath})],1),_c('clubdboardfooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }